import { useTranslation } from 'react-i18next'

import { PermissionsGroup, Text } from '@reveni-io/reveni-ui'

const PermissionsGroups = ({ availablePermissions, permissions, handlePermissionsChange }) => {
  const { t } = useTranslation()

  return (
    <>
      {availablePermissions
        ?.filter(permission => !permission.configurationSection)
        .map(permission => (
          <PermissionsGroup
            key={permission?.label}
            group={permission}
            checkedPermissions={permissions}
            onChange={handlePermissionsChange}
          />
        ))}
      <Text type="titleS">{t('Configuración')}</Text>
      {availablePermissions
        ?.filter(permission => permission.configurationSection)
        .map(permission => (
          <PermissionsGroup
            key={permission?.label}
            group={permission}
            checkedPermissions={permissions}
            onChange={handlePermissionsChange}
          />
        ))}
    </>
  )
}

export default PermissionsGroups
